import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import ChatApp from './components/ChatApp';
import Login from './components/Login';
import { api_django } from './api/robyBackend';
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  const [token, setToken] = useState(localStorage.getItem("access_token"));
  const [loading, setLoading] = useState(true);

  const isAuthenticated = !!token; // Auth-Status direkt vom Token ableiten

  useEffect(() => {
    if (!token) {
      console.log("try load token from localStorage...")
      const access_token = localStorage.getItem('access_token')
      setToken(access_token)
    }
    setLoading(false)
  }, []);

  const handleLoginSuccess = (receivedToken) => {
    localStorage.setItem('access_token', receivedToken);
    setToken(receivedToken);
  };

  function LogoutSuccess() {
    const navigate = useNavigate();

    useEffect(() => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      setToken(null); // Auth zurücksetzen
      navigate('/login/');
    }, [navigate]);

    return <div>Sie wurden erfolgreich ausgeloggt.</div>;
  }

  if (loading) {
    return <div>Lädt...</div>;
  }

  return (
    <ErrorBoundary>
    <Router basename="/">
      <Routes>
        <Route
          path="/login/"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Login onLoginSuccess={handleLoginSuccess} />
            )
          }
        />
        <Route path="/logout-success" element={<LogoutSuccess />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* Root path: show ChatApp when authenticated */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <ChatApp token={token} setToken={setToken} />
            ) : (
              <Navigate to="/login/" replace />
            )
          }
        />
        {/* keep /chat for backward compatibility and redirect to root */}
        <Route
          path="/chat"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Navigate to="/login/" replace />
            )
          }
        />
        <Route
          path="*"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Navigate to="/login/" replace />
            )
          }
        />
      </Routes>
    </Router>
    </ErrorBoundary>
  );
}

export default App;
